import React from 'react'
import { GatsbyBrowser } from 'gatsby'
import { ApolloProvider } from '@apollo/client'
import client from '../context/Client'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => <ApolloProvider client={client}>{element}</ApolloProvider>
